/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as LabelRouteImport } from "./routes/$label"
import { Route as OrganizationRouteRouteImport } from "./routes/organization/route"
import { Route as OperationsRouteRouteImport } from "./routes/operations/route"
import { Route as InstanceRouteRouteImport } from "./routes/instance/route"
import { Route as AppRouteRouteImport } from "./routes/app/route"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as OrganizationIndexRouteImport } from "./routes/organization/index"
import { Route as OperationsIndexRouteImport } from "./routes/operations/index"
import { Route as InstanceIndexRouteImport } from "./routes/instance/index"
import { Route as AppIndexRouteImport } from "./routes/app/index"
import { Route as LtiLaunchRouteImport } from "./routes/lti.launch"
import { Route as LtiErrorRouteImport } from "./routes/lti.error"
import { Route as InviteCodeRouteImport } from "./routes/invite.$code"
import { Route as InstanceDiagnosticsRouteImport } from "./routes/instance/diagnostics"
import { Route as InstanceArrangedAccessRouteImport } from "./routes/instance/arranged-access"
import { Route as LabelSetPasswordRouteImport } from "./routes/$label_.set-password"
import { Route as OrganizationOrganizationIdRouteRouteImport } from "./routes/organization/$organizationId/route"
import { Route as OrganizationOrganizationIdIndexRouteImport } from "./routes/organization/$organizationId/index"
import { Route as OperationsToolIndexRouteImport } from "./routes/operations/$tool/index"
import { Route as InstanceOrganizationsIndexRouteImport } from "./routes/instance/organizations/index"
import { Route as AppChannelIdIndexRouteImport } from "./routes/app/$channelId/index"
import { Route as OrganizationOrganizationIdSettingsRouteImport } from "./routes/organization/$organizationId/settings"
import { Route as OrganizationOrganizationIdAdministratorsRouteImport } from "./routes/organization/$organizationId/administrators"
import { Route as InstanceOrganizationsNewRouteImport } from "./routes/instance/organizations/new"
import { Route as AppChannelIdThreadThreadIdRouteImport } from "./routes/app/$channelId/thread/$threadId"

const LabelRoute = LabelRouteImport.update({
  id: "/$label",
  path: "/$label",
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationRouteRoute = OrganizationRouteRouteImport.update({
  id: "/organization",
  path: "/organization",
  getParentRoute: () => rootRouteImport,
} as any)
const OperationsRouteRoute = OperationsRouteRouteImport.update({
  id: "/operations",
  path: "/operations",
  getParentRoute: () => rootRouteImport,
} as any)
const InstanceRouteRoute = InstanceRouteRouteImport.update({
  id: "/instance",
  path: "/instance",
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: "/app",
  path: "/app",
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationIndexRoute = OrganizationIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => OrganizationRouteRoute,
} as any)
const OperationsIndexRoute = OperationsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => OperationsRouteRoute,
} as any)
const InstanceIndexRoute = InstanceIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => InstanceRouteRoute,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppRouteRoute,
} as any)
const LtiLaunchRoute = LtiLaunchRouteImport.update({
  id: "/lti/launch",
  path: "/lti/launch",
  getParentRoute: () => rootRouteImport,
} as any)
const LtiErrorRoute = LtiErrorRouteImport.update({
  id: "/lti/error",
  path: "/lti/error",
  getParentRoute: () => rootRouteImport,
} as any)
const InviteCodeRoute = InviteCodeRouteImport.update({
  id: "/invite/$code",
  path: "/invite/$code",
  getParentRoute: () => rootRouteImport,
} as any)
const InstanceDiagnosticsRoute = InstanceDiagnosticsRouteImport.update({
  id: "/diagnostics",
  path: "/diagnostics",
  getParentRoute: () => InstanceRouteRoute,
} as any)
const InstanceArrangedAccessRoute = InstanceArrangedAccessRouteImport.update({
  id: "/arranged-access",
  path: "/arranged-access",
  getParentRoute: () => InstanceRouteRoute,
} as any)
const LabelSetPasswordRoute = LabelSetPasswordRouteImport.update({
  id: "/$label_/set-password",
  path: "/$label/set-password",
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationOrganizationIdRouteRoute =
  OrganizationOrganizationIdRouteRouteImport.update({
    id: "/$organizationId",
    path: "/$organizationId",
    getParentRoute: () => OrganizationRouteRoute,
  } as any)
const OrganizationOrganizationIdIndexRoute =
  OrganizationOrganizationIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => OrganizationOrganizationIdRouteRoute,
  } as any)
const OperationsToolIndexRoute = OperationsToolIndexRouteImport.update({
  id: "/$tool/",
  path: "/$tool/",
  getParentRoute: () => OperationsRouteRoute,
} as any)
const InstanceOrganizationsIndexRoute =
  InstanceOrganizationsIndexRouteImport.update({
    id: "/organizations/",
    path: "/organizations/",
    getParentRoute: () => InstanceRouteRoute,
  } as any)
const AppChannelIdIndexRoute = AppChannelIdIndexRouteImport.update({
  id: "/$channelId/",
  path: "/$channelId/",
  getParentRoute: () => AppRouteRoute,
} as any)
const OrganizationOrganizationIdSettingsRoute =
  OrganizationOrganizationIdSettingsRouteImport.update({
    id: "/settings",
    path: "/settings",
    getParentRoute: () => OrganizationOrganizationIdRouteRoute,
  } as any)
const OrganizationOrganizationIdAdministratorsRoute =
  OrganizationOrganizationIdAdministratorsRouteImport.update({
    id: "/administrators",
    path: "/administrators",
    getParentRoute: () => OrganizationOrganizationIdRouteRoute,
  } as any)
const InstanceOrganizationsNewRoute =
  InstanceOrganizationsNewRouteImport.update({
    id: "/organizations/new",
    path: "/organizations/new",
    getParentRoute: () => InstanceRouteRoute,
  } as any)
const AppChannelIdThreadThreadIdRoute =
  AppChannelIdThreadThreadIdRouteImport.update({
    id: "/$channelId/thread/$threadId",
    path: "/$channelId/thread/$threadId",
    getParentRoute: () => AppRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/app": typeof AppRouteRouteWithChildren
  "/instance": typeof InstanceRouteRouteWithChildren
  "/operations": typeof OperationsRouteRouteWithChildren
  "/organization": typeof OrganizationRouteRouteWithChildren
  "/$label": typeof LabelRoute
  "/organization/$organizationId": typeof OrganizationOrganizationIdRouteRouteWithChildren
  "/$label/set-password": typeof LabelSetPasswordRoute
  "/instance/arranged-access": typeof InstanceArrangedAccessRoute
  "/instance/diagnostics": typeof InstanceDiagnosticsRoute
  "/invite/$code": typeof InviteCodeRoute
  "/lti/error": typeof LtiErrorRoute
  "/lti/launch": typeof LtiLaunchRoute
  "/app/": typeof AppIndexRoute
  "/instance/": typeof InstanceIndexRoute
  "/operations/": typeof OperationsIndexRoute
  "/organization/": typeof OrganizationIndexRoute
  "/instance/organizations/new": typeof InstanceOrganizationsNewRoute
  "/organization/$organizationId/administrators": typeof OrganizationOrganizationIdAdministratorsRoute
  "/organization/$organizationId/settings": typeof OrganizationOrganizationIdSettingsRoute
  "/app/$channelId/": typeof AppChannelIdIndexRoute
  "/instance/organizations/": typeof InstanceOrganizationsIndexRoute
  "/operations/$tool/": typeof OperationsToolIndexRoute
  "/organization/$organizationId/": typeof OrganizationOrganizationIdIndexRoute
  "/app/$channelId/thread/$threadId": typeof AppChannelIdThreadThreadIdRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/$label": typeof LabelRoute
  "/$label/set-password": typeof LabelSetPasswordRoute
  "/instance/arranged-access": typeof InstanceArrangedAccessRoute
  "/instance/diagnostics": typeof InstanceDiagnosticsRoute
  "/invite/$code": typeof InviteCodeRoute
  "/lti/error": typeof LtiErrorRoute
  "/lti/launch": typeof LtiLaunchRoute
  "/app": typeof AppIndexRoute
  "/instance": typeof InstanceIndexRoute
  "/operations": typeof OperationsIndexRoute
  "/organization": typeof OrganizationIndexRoute
  "/instance/organizations/new": typeof InstanceOrganizationsNewRoute
  "/organization/$organizationId/administrators": typeof OrganizationOrganizationIdAdministratorsRoute
  "/organization/$organizationId/settings": typeof OrganizationOrganizationIdSettingsRoute
  "/app/$channelId": typeof AppChannelIdIndexRoute
  "/instance/organizations": typeof InstanceOrganizationsIndexRoute
  "/operations/$tool": typeof OperationsToolIndexRoute
  "/organization/$organizationId": typeof OrganizationOrganizationIdIndexRoute
  "/app/$channelId/thread/$threadId": typeof AppChannelIdThreadThreadIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/app": typeof AppRouteRouteWithChildren
  "/instance": typeof InstanceRouteRouteWithChildren
  "/operations": typeof OperationsRouteRouteWithChildren
  "/organization": typeof OrganizationRouteRouteWithChildren
  "/$label": typeof LabelRoute
  "/organization/$organizationId": typeof OrganizationOrganizationIdRouteRouteWithChildren
  "/$label_/set-password": typeof LabelSetPasswordRoute
  "/instance/arranged-access": typeof InstanceArrangedAccessRoute
  "/instance/diagnostics": typeof InstanceDiagnosticsRoute
  "/invite/$code": typeof InviteCodeRoute
  "/lti/error": typeof LtiErrorRoute
  "/lti/launch": typeof LtiLaunchRoute
  "/app/": typeof AppIndexRoute
  "/instance/": typeof InstanceIndexRoute
  "/operations/": typeof OperationsIndexRoute
  "/organization/": typeof OrganizationIndexRoute
  "/instance/organizations/new": typeof InstanceOrganizationsNewRoute
  "/organization/$organizationId/administrators": typeof OrganizationOrganizationIdAdministratorsRoute
  "/organization/$organizationId/settings": typeof OrganizationOrganizationIdSettingsRoute
  "/app/$channelId/": typeof AppChannelIdIndexRoute
  "/instance/organizations/": typeof InstanceOrganizationsIndexRoute
  "/operations/$tool/": typeof OperationsToolIndexRoute
  "/organization/$organizationId/": typeof OrganizationOrganizationIdIndexRoute
  "/app/$channelId/thread/$threadId": typeof AppChannelIdThreadThreadIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/app"
    | "/instance"
    | "/operations"
    | "/organization"
    | "/$label"
    | "/organization/$organizationId"
    | "/$label/set-password"
    | "/instance/arranged-access"
    | "/instance/diagnostics"
    | "/invite/$code"
    | "/lti/error"
    | "/lti/launch"
    | "/app/"
    | "/instance/"
    | "/operations/"
    | "/organization/"
    | "/instance/organizations/new"
    | "/organization/$organizationId/administrators"
    | "/organization/$organizationId/settings"
    | "/app/$channelId/"
    | "/instance/organizations/"
    | "/operations/$tool/"
    | "/organization/$organizationId/"
    | "/app/$channelId/thread/$threadId"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/$label"
    | "/$label/set-password"
    | "/instance/arranged-access"
    | "/instance/diagnostics"
    | "/invite/$code"
    | "/lti/error"
    | "/lti/launch"
    | "/app"
    | "/instance"
    | "/operations"
    | "/organization"
    | "/instance/organizations/new"
    | "/organization/$organizationId/administrators"
    | "/organization/$organizationId/settings"
    | "/app/$channelId"
    | "/instance/organizations"
    | "/operations/$tool"
    | "/organization/$organizationId"
    | "/app/$channelId/thread/$threadId"
  id:
    | "__root__"
    | "/"
    | "/app"
    | "/instance"
    | "/operations"
    | "/organization"
    | "/$label"
    | "/organization/$organizationId"
    | "/$label_/set-password"
    | "/instance/arranged-access"
    | "/instance/diagnostics"
    | "/invite/$code"
    | "/lti/error"
    | "/lti/launch"
    | "/app/"
    | "/instance/"
    | "/operations/"
    | "/organization/"
    | "/instance/organizations/new"
    | "/organization/$organizationId/administrators"
    | "/organization/$organizationId/settings"
    | "/app/$channelId/"
    | "/instance/organizations/"
    | "/operations/$tool/"
    | "/organization/$organizationId/"
    | "/app/$channelId/thread/$threadId"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRouteRoute: typeof AppRouteRouteWithChildren
  InstanceRouteRoute: typeof InstanceRouteRouteWithChildren
  OperationsRouteRoute: typeof OperationsRouteRouteWithChildren
  OrganizationRouteRoute: typeof OrganizationRouteRouteWithChildren
  LabelRoute: typeof LabelRoute
  LabelSetPasswordRoute: typeof LabelSetPasswordRoute
  InviteCodeRoute: typeof InviteCodeRoute
  LtiErrorRoute: typeof LtiErrorRoute
  LtiLaunchRoute: typeof LtiLaunchRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/$label": {
      id: "/$label"
      path: "/$label"
      fullPath: "/$label"
      preLoaderRoute: typeof LabelRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/organization": {
      id: "/organization"
      path: "/organization"
      fullPath: "/organization"
      preLoaderRoute: typeof OrganizationRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/operations": {
      id: "/operations"
      path: "/operations"
      fullPath: "/operations"
      preLoaderRoute: typeof OperationsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/instance": {
      id: "/instance"
      path: "/instance"
      fullPath: "/instance"
      preLoaderRoute: typeof InstanceRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/app": {
      id: "/app"
      path: "/app"
      fullPath: "/app"
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/organization/": {
      id: "/organization/"
      path: "/"
      fullPath: "/organization/"
      preLoaderRoute: typeof OrganizationIndexRouteImport
      parentRoute: typeof OrganizationRouteRoute
    }
    "/operations/": {
      id: "/operations/"
      path: "/"
      fullPath: "/operations/"
      preLoaderRoute: typeof OperationsIndexRouteImport
      parentRoute: typeof OperationsRouteRoute
    }
    "/instance/": {
      id: "/instance/"
      path: "/"
      fullPath: "/instance/"
      preLoaderRoute: typeof InstanceIndexRouteImport
      parentRoute: typeof InstanceRouteRoute
    }
    "/app/": {
      id: "/app/"
      path: "/"
      fullPath: "/app/"
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    "/lti/launch": {
      id: "/lti/launch"
      path: "/lti/launch"
      fullPath: "/lti/launch"
      preLoaderRoute: typeof LtiLaunchRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/lti/error": {
      id: "/lti/error"
      path: "/lti/error"
      fullPath: "/lti/error"
      preLoaderRoute: typeof LtiErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/invite/$code": {
      id: "/invite/$code"
      path: "/invite/$code"
      fullPath: "/invite/$code"
      preLoaderRoute: typeof InviteCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/instance/diagnostics": {
      id: "/instance/diagnostics"
      path: "/diagnostics"
      fullPath: "/instance/diagnostics"
      preLoaderRoute: typeof InstanceDiagnosticsRouteImport
      parentRoute: typeof InstanceRouteRoute
    }
    "/instance/arranged-access": {
      id: "/instance/arranged-access"
      path: "/arranged-access"
      fullPath: "/instance/arranged-access"
      preLoaderRoute: typeof InstanceArrangedAccessRouteImport
      parentRoute: typeof InstanceRouteRoute
    }
    "/$label_/set-password": {
      id: "/$label_/set-password"
      path: "/$label/set-password"
      fullPath: "/$label/set-password"
      preLoaderRoute: typeof LabelSetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/organization/$organizationId": {
      id: "/organization/$organizationId"
      path: "/$organizationId"
      fullPath: "/organization/$organizationId"
      preLoaderRoute: typeof OrganizationOrganizationIdRouteRouteImport
      parentRoute: typeof OrganizationRouteRoute
    }
    "/organization/$organizationId/": {
      id: "/organization/$organizationId/"
      path: "/"
      fullPath: "/organization/$organizationId/"
      preLoaderRoute: typeof OrganizationOrganizationIdIndexRouteImport
      parentRoute: typeof OrganizationOrganizationIdRouteRoute
    }
    "/operations/$tool/": {
      id: "/operations/$tool/"
      path: "/$tool"
      fullPath: "/operations/$tool/"
      preLoaderRoute: typeof OperationsToolIndexRouteImport
      parentRoute: typeof OperationsRouteRoute
    }
    "/instance/organizations/": {
      id: "/instance/organizations/"
      path: "/organizations"
      fullPath: "/instance/organizations/"
      preLoaderRoute: typeof InstanceOrganizationsIndexRouteImport
      parentRoute: typeof InstanceRouteRoute
    }
    "/app/$channelId/": {
      id: "/app/$channelId/"
      path: "/$channelId"
      fullPath: "/app/$channelId/"
      preLoaderRoute: typeof AppChannelIdIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    "/organization/$organizationId/settings": {
      id: "/organization/$organizationId/settings"
      path: "/settings"
      fullPath: "/organization/$organizationId/settings"
      preLoaderRoute: typeof OrganizationOrganizationIdSettingsRouteImport
      parentRoute: typeof OrganizationOrganizationIdRouteRoute
    }
    "/organization/$organizationId/administrators": {
      id: "/organization/$organizationId/administrators"
      path: "/administrators"
      fullPath: "/organization/$organizationId/administrators"
      preLoaderRoute: typeof OrganizationOrganizationIdAdministratorsRouteImport
      parentRoute: typeof OrganizationOrganizationIdRouteRoute
    }
    "/instance/organizations/new": {
      id: "/instance/organizations/new"
      path: "/organizations/new"
      fullPath: "/instance/organizations/new"
      preLoaderRoute: typeof InstanceOrganizationsNewRouteImport
      parentRoute: typeof InstanceRouteRoute
    }
    "/app/$channelId/thread/$threadId": {
      id: "/app/$channelId/thread/$threadId"
      path: "/$channelId/thread/$threadId"
      fullPath: "/app/$channelId/thread/$threadId"
      preLoaderRoute: typeof AppChannelIdThreadThreadIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
  }
}

interface AppRouteRouteChildren {
  AppIndexRoute: typeof AppIndexRoute
  AppChannelIdIndexRoute: typeof AppChannelIdIndexRoute
  AppChannelIdThreadThreadIdRoute: typeof AppChannelIdThreadThreadIdRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppIndexRoute: AppIndexRoute,
  AppChannelIdIndexRoute: AppChannelIdIndexRoute,
  AppChannelIdThreadThreadIdRoute: AppChannelIdThreadThreadIdRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

interface InstanceRouteRouteChildren {
  InstanceArrangedAccessRoute: typeof InstanceArrangedAccessRoute
  InstanceDiagnosticsRoute: typeof InstanceDiagnosticsRoute
  InstanceIndexRoute: typeof InstanceIndexRoute
  InstanceOrganizationsNewRoute: typeof InstanceOrganizationsNewRoute
  InstanceOrganizationsIndexRoute: typeof InstanceOrganizationsIndexRoute
}

const InstanceRouteRouteChildren: InstanceRouteRouteChildren = {
  InstanceArrangedAccessRoute: InstanceArrangedAccessRoute,
  InstanceDiagnosticsRoute: InstanceDiagnosticsRoute,
  InstanceIndexRoute: InstanceIndexRoute,
  InstanceOrganizationsNewRoute: InstanceOrganizationsNewRoute,
  InstanceOrganizationsIndexRoute: InstanceOrganizationsIndexRoute,
}

const InstanceRouteRouteWithChildren = InstanceRouteRoute._addFileChildren(
  InstanceRouteRouteChildren,
)

interface OperationsRouteRouteChildren {
  OperationsIndexRoute: typeof OperationsIndexRoute
  OperationsToolIndexRoute: typeof OperationsToolIndexRoute
}

const OperationsRouteRouteChildren: OperationsRouteRouteChildren = {
  OperationsIndexRoute: OperationsIndexRoute,
  OperationsToolIndexRoute: OperationsToolIndexRoute,
}

const OperationsRouteRouteWithChildren = OperationsRouteRoute._addFileChildren(
  OperationsRouteRouteChildren,
)

interface OrganizationOrganizationIdRouteRouteChildren {
  OrganizationOrganizationIdAdministratorsRoute: typeof OrganizationOrganizationIdAdministratorsRoute
  OrganizationOrganizationIdSettingsRoute: typeof OrganizationOrganizationIdSettingsRoute
  OrganizationOrganizationIdIndexRoute: typeof OrganizationOrganizationIdIndexRoute
}

const OrganizationOrganizationIdRouteRouteChildren: OrganizationOrganizationIdRouteRouteChildren =
  {
    OrganizationOrganizationIdAdministratorsRoute:
      OrganizationOrganizationIdAdministratorsRoute,
    OrganizationOrganizationIdSettingsRoute:
      OrganizationOrganizationIdSettingsRoute,
    OrganizationOrganizationIdIndexRoute: OrganizationOrganizationIdIndexRoute,
  }

const OrganizationOrganizationIdRouteRouteWithChildren =
  OrganizationOrganizationIdRouteRoute._addFileChildren(
    OrganizationOrganizationIdRouteRouteChildren,
  )

interface OrganizationRouteRouteChildren {
  OrganizationOrganizationIdRouteRoute: typeof OrganizationOrganizationIdRouteRouteWithChildren
  OrganizationIndexRoute: typeof OrganizationIndexRoute
}

const OrganizationRouteRouteChildren: OrganizationRouteRouteChildren = {
  OrganizationOrganizationIdRouteRoute:
    OrganizationOrganizationIdRouteRouteWithChildren,
  OrganizationIndexRoute: OrganizationIndexRoute,
}

const OrganizationRouteRouteWithChildren =
  OrganizationRouteRoute._addFileChildren(OrganizationRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRouteRoute: AppRouteRouteWithChildren,
  InstanceRouteRoute: InstanceRouteRouteWithChildren,
  OperationsRouteRoute: OperationsRouteRouteWithChildren,
  OrganizationRouteRoute: OrganizationRouteRouteWithChildren,
  LabelRoute: LabelRoute,
  LabelSetPasswordRoute: LabelSetPasswordRoute,
  InviteCodeRoute: InviteCodeRoute,
  LtiErrorRoute: LtiErrorRoute,
  LtiLaunchRoute: LtiLaunchRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
